import React, { useEffect, useState } from 'react';
import { TextField, FormLabel, Box, Typography, InputAdornment, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormHelperText } from '@mui/material';
import { getCountries } from '../../services/CommonServices';
import { t } from '../../constants/translationHelper';

const StyledTextField = styled(TextField)(({ theme }) => ({
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '4px',
        height: '35px',
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
    },
    '& .MuiInputBase-input': {
        padding: '0 0',

    },
}));

// const countries = [
//     { code: '+91', name: 'United States', flag: 'in' },
//     { code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
//     { code: '+61', name: 'Australia', flag: '🇦🇺' },
//     { code: '+49', name: 'Germany', flag: '🇩🇪' },
//     { code: '+33', name: 'France', flag: '🇫🇷' },
// ];

const CustomMobileField = ({
    name,
    value,
    onChange,
    fieldLabel,
    required,
    helperText,
    placeholder,
    tagLine,
    type,
    InputProps,
    readOnly = false,
    setFieldValue,
    countryCode,
    ...props
}) => {
    const [conutries, setConutries] = useState([]);

    useEffect(() => {
        getCommonData();
    }, []);

    const getCommonData = async () => {
        const getConutriesData = await getCountries();
        setConutries(getConutriesData);
    };

    return (
        <Box style={{ marginBottom: '1px' }}>
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
                <FormLabel style={fieldLabelstyle}>   {fieldLabel ? t(fieldLabel) : ""} </FormLabel>
                <Typography sx={tagLineStyle}>   {tagLine ? t(tagLine) : ""} </Typography>
            </Box>
            <StyledTextField
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder ? t(placeholder) : ""}
                type={type}
                variant="outlined"
                style={required ? { ...style, ...requiredStyle } : style}
                {...props}
                InputProps={{
                    ...InputProps,
                    readOnly: readOnly ? true : undefined,
                    startAdornment: (
                        <InputAdornment position="start">
                            <Select
                                value={countryCode?.id || ''}
                                onChange={(e) => {
                                    const selected = conutries.find(c => c.id === e.target.value);
                                    setFieldValue('phonecodeId', selected?.id || '');
                                }}
                                variant="standard"
                                disableUnderline
                                sx={{ minWidth: 70, fontSize: '0.9rem' }}
                                renderValue={() => {
                                    const selected = conutries.find(c => c.id === countryCode?.id);
                                    return selected ? `+${selected.phonecode}` : '';
                                }}
                            >
                                {conutries.map((country) => (
                                    <MenuItem key={country.id} value={country.id}>
                                        {country.title} (+{country.phonecode})
                                    </MenuItem>
                                ))}
                            </Select>
                        </InputAdornment>
                    )
                }}
            />
            <FormHelperText error={true} style={helperTextStyle}>   {helperText ? t(helperText) : ""} </FormHelperText>
        </Box>
    );
};




export default CustomMobileField;
const style = {
    width: '100%',
    border: '1px solid #CED4DA',
    borderRadius: '4px',
    paddingLeft: '10px',
    height: '35px',
    marginTop: '4px',
    fontFamily: 'Poppins, sans-serif !important',
    color: '#495057',
    fontSize: '14px',
    marginBottom: '3px'
};

const requiredStyle = {
    borderLeft: "2px solid #F27B77",
}

const fieldLabelstyle = {
    color: "#212529",
    fontWeight: "600",
    fontSize: "14px",
    textTransform: "capitalize"

};
const helperTextStyle = {
    fontFamily: 'Poppins, sans-serif !important',
    fontSize: '12px',
    marginTop: 0,
    color: "red",
    textTransform: "capitalize"


}
const tagLineStyle = {
    fontSize: "10px",
    color: "#666",
    paddingLeft: "2px"
};
